import { TipoFiltroCarteiraIntegradores, TipoCampoFiltroCarteiraIntegradores } from './enum';

export class FiltroCarteiraIntegradoresDeAte { de: string; ate: string; }

export class FiltroCarteiraIntegradores {
  id?: TipoFiltroCarteiraIntegradores;
  descricao: string;
  status?: boolean;
  tipo: TipoCampoFiltroCarteiraIntegradores;
  valor?: string | number | FiltroCarteiraIntegradoresDeAte | {};
  items?: any[];
  campoId?: string;
  campoDesc?: string;
  onChange?: Function;
  onActivated?: Function;

  constructor(
    descricao: string,
    tipo: TipoCampoFiltroCarteiraIntegradores,
    id?: TipoFiltroCarteiraIntegradores,
    items?: any[],
    campoDesc?: string,
    campoId?: string,
    onChange?: Function,
    onActivated?: Function,
    valor?: string | number | FiltroCarteiraIntegradoresDeAte | {}
  ) {
    this.id = id,
      this.descricao = descricao,
      this.status = false,
      this.tipo = tipo,
      this.items = items || [
        { id: 1, nome: 'Sim' },
        { id: 0, nome: 'Não' },
      ];
    this.campoDesc = campoDesc || 'nome';
    this.campoId = campoId || 'id';
    this.valor = valor;

    if (onChange) {
      this.onChange = onChange;
    } else {
      this.onChange = () => {
      };
    }

    if (onActivated) {
      this.onActivated = onActivated;
    } else {
      this.onActivated = () => {
      };
    }
  }
}
